import React, { useEffect, useState } from 'react';
import {
  OptionsOrGroups,
  Select,
  SelectChangeEvent,
  SelectOption,
  Typography,
} from '@guildeducationinc/recess';
import classnames from 'classnames';
import snakeCase from 'lodash/snakeCase';
import { clickable } from '@src/analytics';
import { useLearningLifecyclesContext } from '@src/context/LearningLifecyclesContext';
import { createLifecycleSelectOptions } from '@src/utilities/learningLifecyclesUtility';
import styles from './LifecycleSelect.module.scss';

const LifecycleSelect: React.FC = () => {
  const {
    currentLearningLifecycle,
    setCurrentLearningLifecycle,
    learningLifecycles,
  } = useLearningLifecyclesContext();

  const [selectOptions, setSelectOptions] = useState<OptionsOrGroups<SelectOption, any> | []>([]);

  const selectClickable = (label = 'program name') => {
    clickable({
      loggedIn: true,
      product: 'home',
      tag: 'llc_view_steps_toward',
      text: snakeCase(label),
      type: 'select',
    });
  };

  useEffect(() => {
    if (learningLifecycles) {
      const options = createLifecycleSelectOptions(learningLifecycles);
      if (options) {
        setSelectOptions(options);
      }
    }
  }, [learningLifecycles]);

  const handleChange = (event: SelectChangeEvent) => {
    selectClickable(event.selection?.label);
    const selectedLifecycle = learningLifecycles?.find(
      (lifecycle) => lifecycle.applicationId === event.selection?.value
    );
    if (selectedLifecycle && setCurrentLearningLifecycle) {
      setCurrentLearningLifecycle(selectedLifecycle);
    }
  };

  const containerClassNames = classnames(styles.container, 'flex', 'flexItems--center');

  const academicPartnerDisplay = () => {
    const academicPartner = currentLearningLifecycle?.program?.studentFacingAcademicPartner;
    if (academicPartner?.colorLogoUrl) {
      return (
        <>
          <Typography variant='title4'>at</Typography>
          <img
            className={styles.academicPartnerLogo}
            src={academicPartner?.colorLogoUrl}
            alt={academicPartner?.logoAltText}
          />
        </>
      );
    }
    return (
      <Typography variant='title4' className={styles.academicPartnerName}>
        at {academicPartner?.name}
      </Typography>
    );
  };

  return (
    <div className={containerClassNames}>
      <Typography className={styles.label} variant='title4'>
        View steps toward your:
      </Typography>
      <Select
        className={styles.lifecycleSelect}
        isClearable={false}
        label='program'
        hideLabel={true}
        options={selectOptions}
        onChange={handleChange}
        value={currentLearningLifecycle?.applicationId}
      />
      {academicPartnerDisplay()}
    </div>
  );
};

export default LifecycleSelect;
